import { useEffect, useRef } from 'react';
import Suspenseloader from '../../common/splash/suspenseloader';

import { useAuthContext } from 'src/auth/AuthProvider';
import { useHistory } from 'react-router-dom';
import { deleteCookie, getCookie } from 'src/utils/cookie';
import { CookieredirectUrl } from 'src/utils/constants';
import { useRouter } from 'src/shared/hooks';

export function LoginFromCookie() {
  const { handleStoredLogin } = useAuthContext();
  const { push } = useHistory();
  const { history } = useRouter();
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const login = async () => {
      await handleStoredLogin(true);
      const redirectURL = getCookie(CookieredirectUrl);
      if (redirectURL) {
        history.push(redirectURL);
        deleteCookie(CookieredirectUrl);
      } else {
        push('/');
      }
    };

    login();
  }, [handleStoredLogin, push, history]);

  return <Suspenseloader />;
}
